import * as Sentry from "@sentry/nextjs";
import { Options } from "@sentry/types";
import { User } from "@super-real/types";
import { ENVIRONMENT } from "../Common/consts/ENVIRONMENT";

export function setupSentry(options?: Options) {
  if (ENVIRONMENT.nodeEnv !== "production") return;
  if (!ENVIRONMENT.sentry.dsn) return;

  Sentry.init({
    dsn: ENVIRONMENT.sentry.dsn,
    environment: ENVIRONMENT.sentry.environment,
    tracesSampleRate: 1.0,
    debug: false,
    ...options,
  });
}

export function setupSentryUser(user?: User) {
  if (user) {
    Sentry.setUser({
      id: user.id,
      name: user.name,
    });
  } else {
    Sentry.setUser(null);
  }
}
